import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DEPARTMENT_TYPE_WHEELCHAIR } from 'src/app/core/constants';

@Component({
    selector: 'app-wheelchair-attached',
    templateUrl: './wheelchair-attached.component.html',
    styleUrls: ['./wheelchair-attached.component.scss'],
})
export class WheelchairAttachedComponent implements OnInit {
    /**
     * Definição da identificão da sessão/depto Cadeirantes
     */
    public departmentType: string = DEPARTMENT_TYPE_WHEELCHAIR;

    /**
     * Definição do parâmetro recebido via url através do menu sidebar
     */
    public sessionType;

    constructor(private route: ActivatedRoute) {
        this.route.params.subscribe((params) => (this.sessionType = params['sessionType']));
    }

    ngOnInit(): void {
        //console.log('sessionType=' + this.sessionType);
    }
}
